<section class="nrc-banner">
  <div class="centered nrc-banner__centered">
    <aside>
      <h1>See What a New Roof Actually Costs in Your Area</h1>
      <p>Compare reviews, pricing, and promotions from trusted contractors near you</p>
      <div #formWrapper class="nrc-banner__form-wrapper" appStickyZipAnchor>
        <app-new-roof-cost-zip-form
          placeholder="Enter your zip code"
          [fetchedZipcode]="fetchedZipcode"
          [value]="zipValue"
          (valueChange)="zipValueChange.emit($event)"
        />
      </div>
    </aside>
  </div>
  <img
    src="assets/images/roof-image.svg"
    alt=""
    class="nrc-banner__roof-image"
    width="600"
    height="400"
  />
</section>
